import { render, staticRenderFns } from "./InvestmentHistory.vue?vue&type=template&id=00b83502&scoped=true"
import script from "./InvestmentHistory.vue?vue&type=script&lang=js"
export * from "./InvestmentHistory.vue?vue&type=script&lang=js"
import style0 from "./InvestmentHistory.vue?vue&type=style&index=0&id=00b83502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b83502",
  null
  
)

export default component.exports